// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"09c4afb860a4aea22f4d","883":"a9d44a6db8a1a48ef3b6"}[chunkId] + ".js";
};